import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChevronRight, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';

import Tag from '../../tag';

import LogoMangerBouger from '../../assets/svg/logo-header.svg';

import headerStyles from './header.module.css';

const Header = () => {
  const [navigation, setNavigation] = useState(false);

  const handleNavigationClick = useCallback(
    event => {
      event.preventDefault();
      setNavigation(!navigation);
    },
    [navigation]
  );

  const handleTag = (event: React.MouseEvent<HTMLButtonElement>) => {
    const tag = event.currentTarget.getAttribute('data-tag');
    Tag.send(null, `Lien-${tag}`);
  };

  return (
    <header className={headerStyles.header}>
      {navigation}
      <a
        href="/recettes-en-2-2/2020/"
        className={headerStyles.linkMangerBouger}
        onClick={handleTag}
        data-tag="Accueil MangerBouger"
      >
        <LogoMangerBouger className={headerStyles.logo} />
      </a>
      <div className={headerStyles.navigationWrapper}>
        <ul className={headerStyles.ul} role="navigation">
          <li className={headerStyles.li}>
            <button onClick={handleNavigationClick}>
              <FontAwesomeIcon icon={faBars} size="1x" />
            </button>
          </li>
          <li className={headerStyles.li}>
            <a href="https://www.mangerbouger.fr/Votre-recherche">
              <FontAwesomeIcon icon={faSearch} size="1x" />
            </a>
          </li>
        </ul>
        {navigation && (
          <ul className={headerStyles.navigation} role="navigation">
            <li>
              <a href="/" onClick={handleNavigationClick}>
                Accueil
                <span className={headerStyles.closeIcon}>
                  <FontAwesomeIcon icon={faTimes} size="1x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/Le-Mag/Petits-budgets/Nos-astuces-pour-bien-manger-avec-un-petit-budget"
                onClick={handleTag}
                data-tag="Petit budget"
              >
                Petits budgets
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/Manger-mieux/Comment-manger-mieux/Comment-se-regaler-sans-se-ruiner"
                onClick={handleTag}
                data-tag="Se régaler sans se ruiner"
              >
                Comment se régaler sans se ruiner&nbsp;? 
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/Manger-mieux/Comment-manger-mieux/Pourquoi-je-mange-toujours-la-meme-chose"
                onClick={handleTag}
                data-tag="Manger même chose"
              >
                Pourquoi je mange toujours la même chose&nbsp;? 
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/Manger-mieux/Manger-mieux-a-tout-age/Adultes/Comment-varier-son-alimentation-a-tous-les-repas"
                onClick={handleTag}
                data-tag="Varier alimentation"
              >
                Comment varier son alimentation à tous les repas&nbsp;?
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/Manger-mieux/Recettes"
                onClick={handleTag}
                data-tag="Toutes nos recettes"
              >
                Découvrez toutes nos recettes
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                </span>
              </a>
            </li>
          </ul>
        )}
      </div>
    </header>
  );
};

export default Header;
